import React, { useContext, useState } from "react";
import { CapacitorContext } from "../../context/CapacitorContext";
import { ModalContext } from "../../context/ModalContext";
import GuardarMovil from "../movil/GuardarMovil";
import PlantillaForm from "./PlantillaForm";
import Plantillas from "./Plantillas";

const PlantillasButtons = ({
  idChecklist,
  idProyecto,
  sections,
  partidas,
  permiso,
  tipo,
}) => {
  const { modalComponent } = useContext(ModalContext);
  const [showModal, setShowModal] = useState(false);

  const { platform } = useContext(CapacitorContext);

  const hasPartidasPreciario = () => {
    //Connect with preciario
    return false;
  };

  const handleUploadPlantilla = () => {
    modalComponent(
      "Selecciona una Plantilla",
      <Plantillas
        idChecklist={idChecklist}
        idProyecto={idProyecto}
        tipo={tipo}
      />
    );
  };

  const handlePlantilla = () => {
    if (platform === "web") {
      modalComponent(
        "Guardar Plantilla",
        <PlantillaForm idProyecto={idProyecto} tipo={tipo} />
      );
    } else {
      setShowModal(true);
    }
  };

  const handlePreciario = () => {};

  // One "Plantillas" button: the list of plantillas with "Guardar plantilla"
  // on top. An empty obra can load (apply) one; otherwise the list is read-only.
  const handleOpenPlantillas = () => {
    const items = tipo === "cronograma" ? partidas : sections;
    const vacio = Array.isArray(items) && items.length === 0;
    modalComponent(
      "Plantillas",
      <div>
        {Array.isArray(items) && items.length > 0 && (
          <button
            className="btn btn-outline-primary w-100 mb-3"
            onClick={handlePlantilla}
          >
            <i className="fa fa-save me-2"></i>Guardar plantilla actual
          </button>
        )}
        <Plantillas
          idChecklist={idChecklist}
          idProyecto={idProyecto}
          tipo={tipo}
          disabled={!vacio}
        />
      </div>
    );
  };

  const renderButtonsHeader = () => {
    if (platform === "web") {
      return (
        <button
          className="btn btn-outline-primary mb-2"
          onClick={handleOpenPlantillas}
        >
          <i className="fa fa-layer-group me-1"></i> Plantillas
        </button>
      );
    }
    return (
      <div>
        <button
          className="btn btn-primary"
          style={{ marginRight: "2px" }}
          onClick={handlePlantilla}
        >
          <i className="fa fa-print"></i>
        </button>

        <button
          className="btn btn-primary"
          style={{ marginRight: "2px" }}
          onClick={handlePlantilla}
        >
          <i className="fa fa-save"></i>
        </button>

        <button
          className="btn btn-primary"
          style={{ marginRight: "2px" }}
          onClick={handlePlantilla}
        >
          <i className="fa fa-plus"></i>
        </button>
      </div>
    );
  };

  const canSetPlantilla = () => {
    const items = tipo === "cronograma" ? partidas : sections;
    if (Array.isArray(items)) {
      if (items.length === 0) {
        return (
          <div className="d-inline-block">
            <button
              className="btn btn-outline-primary mb-2 me-2"
              onClick={handleUploadPlantilla}
            >
              <i className="fas fa-folder"></i> Cargar Plantilla
            </button>
            {hasPartidasPreciario() && (
              <button
                className="btn btn-outline-primary mb-2 me-2"
                onClick={handlePreciario}
              >
                <i className="fa fa-edit"></i> Cargar Catálogo
              </button>
            )}
          </div>
        );
      }
    }
  };

  const renderButtons = () => {
    if (["admin", "coordinador"].includes(permiso)) {
      return (
        <div className="col-12 px-0">
          {canSetPlantilla()}
          {renderButtonsHeader()}
        </div>
      );
    }
  };

  if (platform === "web") {
    if (!["admin", "coordinador"].includes(permiso)) return null;
    return renderButtonsHeader();
  }

  return (
    <div className="row align-items-center py-2 px-3 px-md-0">
      {renderButtons()}
      <GuardarMovil
        idProyecto={idProyecto}
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default PlantillasButtons;
